<template>
  <div>
    <v-layout wrap row justify-start pa-2 py-5 v-if="superAdmin">
      <v-flex xs12 px-2 mb-2 USERSSETTINGS>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            SYNC
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="goTo('/ar-mo')">SYNC ORDERS</v-btn>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="goTo('/logs-sync')">SYNC LOGS</v-btn>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="goTo('/data-logs')">data LOGS</v-btn>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="resetOldFlash()">Reset Flash</v-btn>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 USERSSETTINGS>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Users
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="instagramLogin">IN LOGIN</v-btn>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t5 = !t5">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t5">
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="users"
                  solo
                  :disabled="loading"
                  :loading="loading"
                  return-object
                  v-model="selectedUser"
                  label="User"
                  :filter="filterObject"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item }"
                  >
                    {{item.name}}
                  </template>
                  <template
                    slot="item"
                    slot-scope="{ parent, item }"
                    class="py-1"
                  >
                      <v-list-tile-action>
                        <v-badge right overlap top small  style="transform: scale(0.5);" :color="`${item.access ? 'success' : 'error'}`">
                          <span slot="badge">
                            <v-avatar
                              size="1"
                              :color="`${item.access ? 'success' : 'error'}`"
                            >
                            </v-avatar>
                          </span>
                            <v-icon  style="transform: scale(1.8);" :color="`${item.superadmin?'error':item.role=='admin'?'success':'primary'}`">account_circle</v-icon>
                        </v-badge>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{item.name}} - <span style="font-size:11px;">{{item.role}}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{item.email}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar v-if="item.inf">
                        <v-chip small label 
                          color="primary" class="white--text">
                          INF
                        </v-chip>
                      </v-list-tile-avatar>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="selectedUser">
                <v-layout row wrap>
                  <v-flex xs12 class="text-xs-left">
                    LAST SEEN: <span style="font-weight:bold;">{{new Date(selectedUser.lastSeen).toISOString().split('T')[0]}}</span> {{new Date(selectedUser.lastSeen).toISOString().split('T')[1].split('.')[0]}}
                  </v-flex>
                  <v-flex xs12 class="text-xs-left">
                    KEY: <span style="font-weight:bold;">{{selectedUser.key}}</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch label="Access" v-model="selectedUser.access" @change="updateUser(selectedUser.key,'access', selectedUser.access)"></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch label="Beta" v-model="selectedUser.beta" @change="updateUser(selectedUser.key,'beta', selectedUser.beta)"></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch label="Q" v-model="selectedUser.q" @change="updateUser(selectedUser.key,'q', selectedUser.q)"></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch label="Influncer" v-model="selectedUser.inf" @change="updateUser(selectedUser.key,'inf', selectedUser.inf)"></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="['whatsapp', 'facebook_comments', 'facebook_messages', 'instagram_comments', 'instagram_messages']"
                      solo
                      multiple
                      :disabled="loading"
                      :loading="loading"
                      v-model="selectedUser.qitems"
                      label="Q items"
                      @change="updateUser(selectedUser.key, 'qitems', selectedUser.qitems)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="waStatuses"
                      solo
                      multiple
                      :disabled="loading"
                      :loading="loading"
                      v-model="selectedUser.wa"
                      label="WA Statuses"
                      @change="updateUser(selectedUser.key, 'wa', selectedUser.wa)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="['agent', 'admin', 'app', 'influencer']"
                      solo
                      :disabled="loading"
                      :loading="loading"
                      v-model="selectedUser.role"
                      label="Role"
                      @change="updateUser(selectedUser.key,'role', selectedUser.role)"
                    ></v-select>
                  </v-flex>
                  
                  <v-flex xs12 v-if="selectedUser.role == 'app'">
                    <v-select
                      :items="['warehouse', 'lastmile']"
                      solo
                      :disabled="loading"
                      :loading="loading"
                      v-model="selectedUser.placement"
                      label="Placement"
                      @change="updateUser(selectedUser.key,'placement', selectedUser.placement)"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="selectedUser.role == 'app'">
                    <v-select
                      :items="warehouses"
                      solo
                      item-text="name"
                      :disabled="loading"
                      :loading="loading"
                      v-model="selectedUser.warehouse"
                      label="Warehouse"
                      @change="updateUser(selectedUser.key,'warehouse', selectedUser.warehouse)"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t5">
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 ORDERLOCK>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Orders Lock Settings
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t1 = !t1">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t1">
            <v-layout row wrap>
              <v-flex xs12>
                {{beforeDate}}
              </v-flex>
              <v-flex xs12>
                <v-menu
                  v-model="fsd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template slot="activator">
                    <v-text-field
                      v-model="beforeDate"
                      label="Lock orders before date"
                      append-icon="event"
                      readonly
                      solo
                      hide-details
                      clearable
                      @change="updateLock()"
                      :loading="loading"
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="updateLock()" v-model="beforeDate" @input="fsd = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t1">
            <v-spacer></v-spacer>
            <v-btn :loading="loading" :disabled="loading" color="primary" @click="updateLock()">update lock</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2  mb-2 Q>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Q Settings
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t2 = !t2">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-switch label="Q Active" v-model="qactive" @change="saveQ()"></v-switch>
              </v-flex>
            </v-layout>
          </v-card-text >
          <v-card-actions v-if="t2">
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 IPBLOCK>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            IP Block
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t3 = !t3">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t3">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="IP to block (ENTER)"
                  label="IP to block (ENTER)"
                  solo
                  v-model.trim="blockip"
                  @keypress.enter="addToBlockList()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t3">
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" :loading="loading" color="error" @click="addToBlockList()">block</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 NUMBERBLOCK>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            NUMBER Block
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t6 = !t6">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t6">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="NUMBER to block (ENTER)"
                  label="NUMBER to block (ENTER)"
                  solo
                  v-model.trim="blocknumber"
                  @keypress.enter="addToNumberBlockList()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t6">
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" :loading="loading" color="error" @click="addToNumberBlockList()">block</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 Announcments>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Announcments
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t7 = !t7">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t7">
            <v-layout row wrap align-center>
              <v-flex xs12 v-for="(ann, a) in announcments" :key="'ann-'+a">
                <v-layout row wrap align-center>
                  <v-flex xs8>
                    {{ann.title}}
                    {{ann.date}}
                  </v-flex>
                  <v-flex xs4>
                    <v-btn :disabled="loading" :loading="loading" flat icon small color="error" @click="deleteAnnouncments(ann.key)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="Announcments Title"
                  label="Announcments Title"
                  solo
                  v-model.trim="announcmentTitle"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Announcments Details"
                  label="Announcments Details"
                  solo
                  v-model.trim="announcmentDetails"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t7">
            <v-spacer></v-spacer>
            <v-btn :disabled="loading" :loading="loading" color="error" @click="addAnnouncments()">add</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 COMPANYCODES>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Company Codes
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t8 = !t8">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t8">
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  name="Select Company Code to edit"
                  label="Select Company Code to edit"
                  solo
                  :items="company_codes"
                  v-model="companyCode"
                  item-text="company_code"
                  return-object
                  append-outer-icon="fiber_new"
                  @click:append-outer="()=>{
                    companyCode = {}
                  }"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Company Code"
                  label="Company Code"
                  solo
                  v-model.trim="companyCode.company_code"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Company Name Ar"
                  label="Company Name Ar"
                  solo
                  v-model.trim="companyCode.company_ar"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Company Name En"
                  label="Company Name En"
                  solo
                  v-model.trim="companyCode.company_en"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  name="Countries"
                  label="Countries"
                  solo
                  multiple
                  item-text="name"
                  :items="countries"
                  v-model.trim="companyCode.countries"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="warehouses"
                  solo
                  item-text="name"
                  :disabled="loading"
                  :loading="loading"
                  multiple
                  item-value="name"
                  v-model="companyCode.warehouses"
                  label="Warehouses"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Policy Link"
                  label="Policy Link"
                  solo
                  v-model.trim="companyCode.policy"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Delivery Fees"
                  label="Delivery Fees"
                  solo
                  v-model.trim="companyCode.delivery_fees"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Tax"
                  label="Tax"
                  solo
                  v-model.trim="companyCode.tax"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Free Delivery Limit"
                  label="Free Delivery Limit"
                  solo
                  v-model.trim="companyCode.free_delivery_limit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="Delivery Days"
                  label="Delivery Days"
                  solo
                  v-model.trim="companyCode.ddays"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t8">
            <v-spacer></v-spacer>
            <v-btn :loading="loading" color="error" v-if="companyCode.key" @click="updateCompanyCode()">update</v-btn>
            <v-btn :loading="loading" color="success" v-if="!companyCode.key" @click="newCompanyCode()">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 MESSENGER-DELETE>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Messenger DELETE
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t9 = !t9">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t9">
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  name="Select Phrase to edit"
                  label="Select Phrase to edit"
                  solo
                  :items="deletePhrases"
                  v-model="deletePhrase"
                  item-text="phrase"
                  return-object
                  append-outer-icon="fiber_new"
                  @click:append-outer="()=>{
                    deletePhrase = {}
                  }"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Phrase"
                  solo
                  v-model.trim="deletePhrase.phrase"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Message"
                  solo
                  v-model.trim="deletePhrase.message"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t9">
            <v-spacer></v-spacer>
            <v-btn :loading="loading" color="error" v-if="deletePhrase.key" @click="updateDeletePhrase()">update</v-btn>
            <v-btn :loading="loading" color="success" v-if="!deletePhrase.key" @click="newDeletePhrase()">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs6 px-2 mb-2 MESSENGER-HIDE>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Messenger HIDE
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t10 = !t10">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t10">
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  name="Select Phrase to edit"
                  label="Select Phrase to edit"
                  solo
                  :items="hidePhrases"
                  v-model="hidePhrase"
                  item-text="phrase"
                  return-object
                  append-outer-icon="fiber_new"
                  @click:append-outer="()=>{
                    hidePhrase = {}
                  }"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Phrase"
                  solo
                  v-model.trim="hidePhrase.phrase"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Message"
                  solo
                  v-model.trim="hidePhrase.message"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t10">
            <v-spacer></v-spacer>
            <v-btn :loading="loading" color="error" v-if="hidePhrase.key" @click="updateHidePhrase()">update</v-btn>
            <v-btn :loading="loading" color="success" v-if="!hidePhrase.key" @click="newHidePhrase()">save</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 px-2 mb-2 INFLUNECERS>
        <v-card class="elevation-24 text-md-center">
          <v-card-title class="headline white--text primary">
            Influncers Settings
            <v-spacer></v-spacer>
            <v-btn color="secondary" :loading="loading" :disabled="loading" @click="t4 = !t4">toggle
            </v-btn>
          </v-card-title>
          <v-card-text v-if="t4">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 SELECTUSER>
                <v-autocomplete
                  :items="users.filter(x=>x.role =='influencer')"
                  solo
                  :disabled="loading"
                  :loading="loading"
                  return-object
                  v-model="selectedUser"
                  label="User"
                  :filter="filterObject"
                >
                  <template
                    slot="selection"
                    slot-scope="{ item }"
                  >
                    {{item.name}}
                  </template>
                  <template
                    slot="item"
                    slot-scope="{ parent, item }"
                    class="py-1"
                  >
                      <v-list-tile-action>
                        <v-badge right overlap top small  style="transform: scale(0.5);" :color="`${item.access ? 'success' : 'error'}`">
                          <span slot="badge">
                            <v-avatar
                              size="1"
                              :color="`${item.access ? 'success' : 'error'}`"
                            >
                            </v-avatar>
                          </span>
                            <v-icon  style="transform: scale(1.8);" :color="`${item.superadmin?'error':item.role=='admin'?'success':'primary'}`">account_circle</v-icon>
                        </v-badge>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{item.name}} - <span style="font-size:11px;">{{item.role}}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          {{item.email}}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-avatar v-if="item.inf">
                        <v-chip small label 
                          color="primary" class="white--text">
                          INF
                        </v-chip>
                      </v-list-tile-avatar>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 v-if="selectedUser" SITE>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">BASIC SETTINGS</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Company Code</div>
                    <v-autocomplete
                      name="Select Company Code"
                      label="Select Company Code"
                      solo
                      :items="company_codes"
                      item-text="company_code"
                      item-value="company_code"
                      v-model.trim="selectedUser.company_code"
                      @change="updateUser(selectedUser.key,'company_code', selectedUser.company_code)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">DID</div>
                    <v-text-field
                      name="DID"
                      label="DID"
                      solo
                      hide-details
                      v-model.trim="selectedUser.did"
                      @change="updateUser(selectedUser.key,'did', selectedUser.did)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider v-if="t4 && selectedUser"></v-divider>
          <v-card-text v-if="t4 && selectedUser">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 v-if="selectedUser" CRM>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">CRM DESIGN & SETTINGS</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Site name</div>
                    <v-text-field
                      name="Site name"
                      label="Site name"
                      solo
                      hide-details
                      v-model.trim="selectedUser.sitename"
                      @change="updateUser(selectedUser.key,'sitename', selectedUser.sitename)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Logo</div>
                    <v-text-field
                      name="Logo"
                      label="Logo"
                      solo
                      hide-details
                      v-model.trim="selectedUser.logo"
                      @change="updateUser(selectedUser.key,'logo', selectedUser.logo)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Favicon</div>
                    <v-text-field
                      name="Favicon"
                      label="Favicon"
                      solo
                      hide-details
                      v-model.trim="selectedUser.favicon"
                      @change="updateUser(selectedUser.key,'favicon', selectedUser.favicon)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Primary Color</div>
                    <v-text-field
                      name="Primary Color"
                      label="Primary Color"
                      solo
                      hide-details
                      v-model.trim="selectedUser.primary"
                      @change="updateUser(selectedUser.key,'primary', selectedUser.primary)"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Secondary Color</div>
                    <v-text-field
                      name="Secondary Color"
                      label="Secondary Color"
                      solo
                      hide-details
                      v-model.trim="selectedUser.secondary"
                      @change="updateUser(selectedUser.key,'secondary', selectedUser.secondary)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider v-if="t4 && selectedUser"></v-divider>
          <v-card-text v-if="t4 && selectedUser">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 v-if="selectedUser" SITE>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">Call Center Settings</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Charge on Confirm Only</div>
                    <v-switch label="Charge on Confirm Only" v-model="selectedUser.onconfirm" 
                      @change="updateUser(selectedUser.key,'onconfirm', selectedUser.onconfirm)">
                    </v-switch>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Amount per CALL/CONFIRM</div>
                    <v-text-field
                      name="Amount per CALL/CONFIRM"
                      label="Amount per CALL/CONFIRM"
                      solo
                      @keypress="isNumber($event)"
                      hide-details
                      v-model.trim="selectedUser.costcallcenter"
                      @change="updateUser(selectedUser.key,'costcallcenter', selectedUser.costcallcenter)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider v-if="t4 && selectedUser"></v-divider>
          <v-card-text v-if="t4 && selectedUser">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 v-if="selectedUser" SITE>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">Delivery Settings</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Charge on Delivered only</div>
                    <v-switch label="Charge on Delivered only" v-model="selectedUser.ondelivered" 
                      @change="updateUser(selectedUser.key,'ondelivered', selectedUser.ondelivered)">
                    </v-switch>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Amount per DELIVERED/OUT FOR DELIVERY</div>
                    <v-text-field
                      name="Amount per DELIVERED/OUT FOR DELIVERY"
                      label="Amount per DELIVERED/OUT FOR DELIVERY"
                      solo
                      @keypress="isNumber($event)"
                      hide-details
                      v-model.trim="selectedUser.costdelivery"
                      @change="updateUser(selectedUser.key,'costdelivery', selectedUser.costdelivery)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider v-if="t4 && selectedUser"></v-divider>
          <v-card-text v-if="t4 && selectedUser">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 v-if="selectedUser" SITE>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">COD Settings</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Charge fixed per order</div>
                    <v-switch label="Charge fixed per Order" v-model="selectedUser.cod" 
                      @change="updateUser(selectedUser.key,'cod', selectedUser.cod)">
                    </v-switch>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Amount/Percentage per Order</div>
                    <v-text-field
                      name="Amount/Percentage per Order"
                      label="Amount/Percentage per Order"
                      solo
                      @keypress="isNumber($event)"
                      hide-details
                      v-model.trim="selectedUser.costcod"
                      @change="updateUser(selectedUser.key,'costcod', selectedUser.costcod)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider v-if="t4 && selectedUser"></v-divider>
          <v-card-text v-if="t4 && selectedUser">
            <v-layout row wrap class="text-xs-left">
              <v-flex xs12 v-if="selectedUser" SITE>
                <div style="font-size:12px;font-weight:bold;" class="pa-1">Fulfilment Settings</div>
                <v-layout row wrap>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Fulfilment per order</div>
                    <v-switch label="Fulfilment per Order" v-model="selectedUser.fulfilment" 
                      @change="updateUser(selectedUser.key,'fulfilment', selectedUser.fulfilment)">
                    </v-switch>
                  </v-flex>
                  <v-flex xs6 pa-1>
                    <div style="font-size:12px;font-weight:bold;" class="pa-1">Fulfilment cost per Order</div>
                    <v-text-field
                      name="Fulfilment cost per Order"
                      label="Fulfilment cost per Order"
                      solo
                      @keypress="isNumber($event)"
                      hide-details
                      v-model.trim="selectedUser.costfulfilment"
                      @change="updateUser(selectedUser.key,'costfulfilment', selectedUser.costfulfilment)"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions v-if="t4 && selectedUser">
            <v-spacer></v-spacer>
            <v-btn color="success">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import countriesJSON from '@/countries-ash.json'

import axios from 'axios';
import { productApiUrl } from '@/config/urls';
export default {
  components:{}, 
  data(){
    return {
      t1:false,
      t2:false,
      t3:false,
      t4:false,
      t5:false,
      t6:false,
      t7:false,
      t8:false,
      t9:false,
      t10:false,
			loading: false,
      users:[],
      selectedUser:null,
      warehouses:[],
      waStatuses:[],
      qactive:false,
      beforeDate:null,
      fsd:null,
      blockip:null,
      blocknumber:null,
      announcmentTitle:null,
      announcmentDetails:null,
      announcments:null,
      companyCode:{},
      countries:[],
      company_codes:[],
      messengerDelete:[],
      deletePhrases:[],
      deletePhrase:{},
      hidePhrases:[],
      hidePhrase:{},
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    async loadHidePhrases(){
      this.loading = true
      let a = await db.ref('settings/hidePhrases').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.hidePhrases = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.hidePhrase = {}
      this.loading = false
    },
    async updateHidePhrase(){
      this.loading = true
      if(!this.hidePhrase.phrase || !this.hidePhrase.message) {
        this.loading = false
        return true
      }
      await db.ref(`settings/hidePhrases/${this.hidePhrase.key}`).update(this.hidePhrase)
      this.loadHidePhrases()
      this.loading = false
    },
    async newHidePhrase(){
      this.loading = true
      if(this.hidePhrase.key) {
        this.loading = false
        return true
      }
      if(!this.hidePhrase.phrase || !this.hidePhrase.message ) {
        this.loading = false
        return true
      }
      await db.ref('settings/hidePhrases').push(this.hidePhrase)
      this.loadHidePhrases()
      this.loading = false
    },
    async loadDeletePhrases(){
      this.loading = true
      let a = await db.ref('settings/deletePhrases').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.deletePhrases = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.deletePhrase = {}
      this.loading = false
    },
    async updateDeletePhrase(){
      this.loading = true
      if(!this.deletePhrase.phrase || !this.deletePhrase.message) {
        this.loading = false
        return true
      }
      await db.ref(`settings/deletePhrases/${this.deletePhrase.key}`).update(this.deletePhrase)
      this.loadDeletePhrases()
      this.loading = false
    },
    async newDeletePhrase(){
      this.loading = true
      if(this.deletePhrase.key) {
        this.loading = false
        return true
      }
      if(!this.deletePhrase.phrase || !this.deletePhrase.message ) {
        this.loading = false
        return true
      }
      await db.ref('settings/deletePhrases').push(this.deletePhrase)
      this.loadDeletePhrases()
      this.loading = false
    },
    async updateDBCompanyCodes(){
      return new Promise(async (res, rej)=>{
        let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
        if(a) {
          let c = Object.values(a).map((x, i)=> x.company_code.toUpperCase() )
          await db.ref('companies').update(c)
          await db.ref('settings/dbfilters/companycodes').update(c)
          console.log(c)
          res(c)
        }
      })
    },
    async updateCompanyCode(){
      this.loading = true
      if(!this.companyCode.company_code 
        || !this.companyCode.countries 
        || !this.companyCode.countries.length
        || !this.companyCode.warehouses 
        || !this.companyCode.warehouses.length
        ) {
        this.loading = false
        return true
      }
      this.companyCode.company_code = this.companyCode.company_code.toUpperCase().trim()
      await db.ref(`settings/company_codes/${this.companyCode.key}`).update(this.companyCode)
      await this.updateDBCompanyCodes()
      this.loadCompanyCodes()
      this.loading = false
    },
    async newCompanyCode(){
      this.loading = true
      if(this.companyCode.key) {
        return true
        this.loading = false
      }
      if(!this.companyCode.company_code 
        || !this.companyCode.countries 
        || !this.companyCode.countries.length
        || !this.companyCode.warehouses 
        || !this.companyCode.warehouses.length
        ) {
        this.loading = false
        return true
      }
      this.companyCode.company_code = this.companyCode.company_code.toUpperCase().trim()
      await db.ref('settings/company_codes').push(this.companyCode)
      await this.updateDBCompanyCodes()
      this.loadCompanyCodes()
      this.loading = false
    },
    async loadCompanyCodes(){
      this.loading = true
      let a = await db.ref('settings/company_codes').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.company_codes = Object.values(a).map((x, i)=>{
          return {
            ...x,
            key:b[i]
          }
        })
      }
      this.companyCode = {}
      this.loading = false
    },
    async getCountries() {
      let a = await db.ref('settings/countrieslite').once('value').then(x=>x.val())
      if(a){
        this.countries = Object.values(a)
      }
    },
    async syncCountries() {
      let a = await db.ref('countries').once('value').then(x=>x.val())
      if(a){
        this.countries = Object.values(a);
        let lite = []
        for (let i = 0; i < this.countries.length; i++) {
          const c = this.countries[i];
          console.log(c)
          let kk = Object.keys(c).filter(x=> typeof c[x] != 'object' || x == 'callingCodes')
          let d = {}
          kk.forEach(x=>d[x]=c[x])
          lite.push(d)
        }
        await db.ref('settings').update({countrieslite:lite})
        // import currencies 
        // (async x=>{
        //   for (let i = 0; i < this.countries.length; i++) {
        //     const c = this.countries[i];
        //     console.log(c);
        //     if(c.currencies && c.currencies.length) {
        //       let cc = c.currencies[0].code
        //       console.log(cc);
        //       if(cc && cc != '(none)' && c.usd) {
        //         await db.ref('settings/app/currencies').update({
        //           [cc]:c.usd
        //         })
        //       }
        //     }
        //   }
        // })()
      }
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async loadAnnouncments(){
      let a = await db.ref('announcments').once('value').then(x=>x.val())
      if(a){
        let b = Object.keys(a)
        this.announcments = Object.values(a).map((x, i)=>{
          return {
            ...x,
            date:new Date(x.date).toISOString().split('T')[0],
            key:b[i]
          }
        })
      }
    },
    async deleteAnnouncments(key){
      this.announcmentTitle = null
      this.announcmentDetails = null
      await db.ref('announcments').update({[key]:null})
      this.announcments = []
      this.loadAnnouncments()
    },
    async addAnnouncments(){
      await db.ref('announcments').push({title:this.announcmentTitle, details:this.announcmentDetails, date:new Date().getTime()})
      this.$emit('snackbarNotification', `Added ${this.announcmentTitle}`, 'success')
      this.announcmentTitle = null
      this.announcmentDetails = null
      this.loadAnnouncments()
    },
    async addToNumberBlockList() {
      await db.ref('blocknumberlist').push({number:this.blocknumber})
      this.$emit('snackbarNotification', `Blocked ${this.blocknumber}`, 'success')
      this.blocknumber = null
    },
    async addToBlockList() {
      await db.ref('blocklist').push({ip:this.blockip})
      this.$emit('snackbarNotification', `Blocked ${this.blockip}`, 'success')
      this.blockip = null
    },
    async updateLock() {
      let a = new Date(this.beforeDate).getTime()
      await db.ref(`settings`).update({lockdate:a});
      this.$emit('snackbarNotification', `Updated`, 'success')
      this.loadLock()
    },
    async loadLock(){
      let a = await db.ref(`settings/lockdate`).once('value').then(x=>x.val());
      let b = new Date(a).toISOString().split('T')[0]
      this.beforeDate = b
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          key:y.id
        }
      }))
      console.log(this.warehouses)
      this.loading = false
    },
    async getAllUsers(){
      this.loading = true
      let a = await db.ref('users').once('value').then(x=>x.val())
      let b = Object.keys(a)
      let c = Object.values(a).map((d, i)=>{
        return {
          ...d,
          key:b[i]
        }
      })
      this.users = c
      this.loading = false

    },
    async updateUser(key,item, x) {
      await db.ref(`users/${key}`).update({
        [item]:x
      })
      this.$emit('snackbarNotification', `Updated`, 'success')
    },
    async OauthLogin () {
      let token = await db.ref('settings/fb/token').once('value').then(x=>x.val())
      FB.api('/me', function(response) {
        console.log('me', response);
        console.log('Good to see you, ' + response.name + '.');
      }, {access_token:token});

      FB.login(function(response) {
        // handle the response
        console.log('login', response)
        if(response.authResponse && response.authResponse.accessToken) {
          db.ref('settings/fb').update({token:response.authResponse.accessToken})
        }
      }, {
          scope: 'email, pages_manage_cta, pages_show_list, ads_management, ads_read, business_management, pages_messaging, instagram_manage_comments, pages_read_engagement, pages_read_user_content, pages_manage_ads, pages_manage_posts, pages_manage_engagement, public_profile', 
          return_scopes: true,
          auth_type:'rerequest',
          enable_profile_selector:true,
      });
      
      let x = await axios.get(`https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=968096253690481&client_secret=297c9b7ff6830eceed6b93f973b46914&fb_exchange_token=${token}`).then(x=>x.data)
      console.log(x)
      await db.ref('settings/fb').update({long_token:x.access_token})
      
    },
    async instagramLogin(){
      let post = {
        client_id:'2985109935079685',
        scope:'instagram_graph_user_media,instagram_graph_user_profile',
        response_type:'code',
        redirect_uri:'https://ashyaatcrm.firebaseapp.com/user-settings',
      }
      let a = await axios.post(`https://api.instagram.com/oauth/authorize`, post).then(x=>x.data)
      console.log(a)
      let token_p = {
        client_id:'6da1deaf2288cf0511ff5bb43c88a095',
        redirect_uri:'https://ashyaatcrm.firebaseapp.com/user-settings',
        grant_type:'ig_exchange_token',
        access_token: a.access_token
      }
      let b = await axios.post(`https://graph.instagram.com/access_token`, token_p).then(x=>x.data)
      console.log(b)
    },
    signOut(){
      try {
        auth.getInstance().signOut();
      } catch (error) {
        
      }
    },
    getWAStatuses(){
      db.ref(`wastatuses`).once('value')
      .then(x=>{
        let ss = x.val()
        for (const key in ss) {
          if (ss.hasOwnProperty(key)) {
            const s = ss[key];
            this.waStatuses.push(s.name)
          }
        }
      })
    },
    async saveQ() {
      await db.ref('settings/q').update({active:this.qactive})
      this.$emit('snackbarNotification', `Updated`, 'success')
    },
    async getQ(){
      this.qactive = await db.ref('settings/q/active').once('value').then(x=>x.val())
    },
    async resetOldFlash() {
      this.loading = true
      const r = await axios.get(productApiUrl('reset-old-flash')).then(x=>x.data)
      this.$emit('snackbarNotification', `Reset ${r} Items`, 'success')
      this.loading = false
    }
  },
  props:{
		userName:{
			default:null
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
  },
  computed:{
    
  },
  async created(){
    this.getAllUsers()
    this.getWarehouses()
    this.getWAStatuses()
    this.getQ()
    this.loadLock()
    this.loadAnnouncments()
    this.getCountries()
    this.loadCompanyCodes()
    this.loadDeletePhrases()
    this.loadHidePhrases()

    FB.login( async function(response) {
      if(response.authResponse && response.authResponse.accessToken) {
          await db.ref('settings/fb').update({token:response.authResponse.accessToken})
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    });
    let token = await db.ref('settings/fb/token').once('value').then(x=>x.val())
    let x = await axios.get(`https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=968096253690481&client_secret=297c9b7ff6830eceed6b93f973b46914&fb_exchange_token=${token}`).then(x=>x.data)
    console.log(x)
    await db.ref('settings/fb').update({long_token:x.access_token})
    
    // let y = await axios.get(`https://graph.facebook.com/104019097786523?fields=access_token&access_token=${token}`).then(x=>x.data)
    // console.log('page', y)
    // await db.ref('settings/fb').update({page_token:y.access_token})

    // async function getNextPage(path){
    //   return new Promise(async (res,rej)=>{
    //     let page_token = await db.ref('settings/fb/page_token').once('value').then(x=>x.val())
    //     let posts = []
    //     let start = `${path}access_token=${page_token}`
    //     let first = true
    //     let re = {};
    //     do {
    //       try {
    //         re = await axios.get(start).then(x=>x.data)
    //         posts.push(...re.data)
    //         start = re.paging? re.paging.next : null
    //         first = false
    //       } catch (error) {}
    //     } while (first || start);
    //     console.log('all posts', posts)
    //     res(posts)
    //   })
    // }

    // let asyncposts = await getNextPage(`https://graph.facebook.com/v8.0/104019097786523/ads_posts?include_inline_create=true&`)
    // console.log('resolved all posts', asyncposts);
    // (async x=>{
    //   for (let i = 0; i < asyncposts.length; i++) {
    //     console.log(i)
    //     const post = asyncposts[i];
    //     try {
    //       let com = await getNextPage(`https://graph.facebook.com/v8.0/${post.id}/comments?`)
    //       if(!asyncposts[i].comments) asyncposts[i].comments = []
    //       asyncposts[i].comments.push(...com)
    //       let comments = asyncposts[i].comments
    //       for (let k = 0; k < asyncposts[i].comments.length; k++) {
    //         const comment = asyncposts[i].comments[k];
    //         let c = await getNextPage(`https://graph.facebook.com/v8.0/${comment.id}/comments?`)
    //         if(!asyncposts[i].comments[k].replies) asyncposts[i].comments[k].replies = []
    //         asyncposts[i].comments[k].replies.push(...c)
    //       }
    //     } catch (error) {
    //     }
    //   }
    //   console.log('final', asyncposts)
    //   console.log('final', asyncposts.filter(x=>x.comments))
    //   console.log('final', asyncposts.filter(x=>x.comments.filter(x=>x.replies)))
    // })()

    // let page_token = await db.ref('settings/fb/page_token').once('value').then(x=>x.val())
    // let re = await axios.get(`https://graph.facebook.com/v8.0/104019097786523/ads_posts?include_inline_create=true&access_token=${page_token}`).then(x=>x.data)
    // console.log(re)
    // let posts = re.data;

    // console.log(posts);
    // (async x=>{
    //   for (let i = 0; i < posts.length; i++) {
    //     const post = posts[i];
    //     try {
    //       let com = await axios.get(`https://graph.facebook.com/v8.0/${post.id}/comments?access_token=${page_token}`).then(x=>x.data)
    //       if(!posts[i].comments) posts[i].comments = []
    //       posts[i].comments.push(...com.data)
    //       let comments = posts[i].comments
    //       for (let k = 0; k < posts[i].comments.length; k++) {
    //         const comment = posts[i].comments[k];
    //         let c = await axios.get(`https://graph.facebook.com/v8.0/${comment.id}/comments?access_token=${page_token}`).then(x=>x.data)
    //         if(!posts[i].comments[k].replies) posts[i].comments[k].replies = []
    //         posts[i].comments[k].replies.push(c)
    //       }

    //     } catch (error) {
    //     }
    //   }
    //   console.log('final', posts)
    //   console.log('final', posts.filter(x=>x.comments))
    //   console.log('final', posts.filter(x=>x.comments.filter(x=>x.replies)))
    // })()


    

  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
